import { MediaId } from "@mp-commons/model/MediaInfo.js";
import { VideoInfoRawData } from "@mp-commons/model/video/VideoInfo.js";
import { ExternallyPassedContentAdData } from "@mp-commons/modules/ads/adcall/composable/ContentSpecificAdCallFilter.js";
import { GDPRSdk } from "@ciaopeople/cp-shatsu/GDPR";
import { AdErrorStruct, PlayerAdEvent, PlayerAdEventType, isPlayerAdCompleteEvent, isPlayerAdPausedEvent, isPlayerAdResumedEvent, isPlayerAdStartedEvent } from "@mp-commons/modules/ads/PlayerAdEvent.js";
import { MediaControlOrigin, MediaEvent, MediaProgressEvent, isMediaBufferEndEvent, isMediaBufferingEvent, isMediaCompleteEvent, isMediaPausedEvent, isMediaPlaylistStartedEvent, isMediaResumedEvent, isMediaStartedEvent } from "@mp-commons/modules/events/PlayerEvent.js";
import { ComScoreConfig, ComScoreStreamingTagFactory } from "@mp-commons/modules/stats/collectors/comscore/ComScoreStreamingTag.js";
import { ComScoreStreamingTagDynamic } from "@mp-commons/modules/stats/collectors/comscore/ComScoreStreamingTagDynamic.js";
import { AudicomConfig, AudicomPairingPing, AudicomPairingPingFactory } from "@mp-commons/modules/stats/collectors/AudicomPairingPing.js";
import { PreFilteredEventMapper } from "@mp-commons/modules/stats/mappers/PreFilteredEventMapper.js";
import { generateUID } from "@mp-commons/lib/utils/Utility.js";

export interface MegarideAudicomConfig {  
    audicom: AudicomConfig,
    comscore: ComScoreConfig
}   

export class MegarideAudicomMapper extends PreFilteredEventMapper<VideoInfoRawData> {


    private comscoreFactory: ComScoreStreamingTagFactory;
    private pairingPingFactory: AudicomPairingPingFactory;


    private activeItem: { [k: MediaId]: "ad" | "video" };


    constructor(private window: Window,
        cfg: MegarideAudicomConfig,
        gdpr: Promise<GDPRSdk>,
        externalData?: ExternallyPassedContentAdData
    ) {
        super({
            media: true,
            adevents: [
                PlayerAdEventType.AD_STARTED,
                PlayerAdEventType.AD_COMPLETED,
                PlayerAdEventType.AD_RESUMED,
                PlayerAdEventType.AD_PAUSED
            ]
        });

        this.comscoreFactory = new ComScoreStreamingTagDynamic(cfg.comscore, gdpr, this.window, externalData, cfg.audicom);
        this.pairingPingFactory = new AudicomPairingPing(gdpr, cfg.audicom);
    }



    public preload(): Promise<void> {
        if (this.comscoreFactory instanceof ComScoreStreamingTagDynamic) {
            return this.comscoreFactory.preload().then();
        }
        else return Promise.resolve();
    }


    protected onAdError(errorStruct: AdErrorStruct, adjustedLabel?: string, adjustedEventLabel?: string): void {
        //nothing to do
    }
    protected onAdEvent(evt: PlayerAdEvent, adjustedLabel?: string, adjustedEventLabel?: string): void {

        if (isPlayerAdStartedEvent(evt) && evt.adInfo.linear) {
            this.comscoreFactory.getStreamingTag(evt).then(tag => {
                //tag.end();
                tag.adStarted(evt);
            });
        }
        else if (isPlayerAdCompleteEvent(evt)) {
            this.comscoreFactory.getStreamingTag(evt).then(tag => {
                tag.adEnded();
            });
        }
        else if (isPlayerAdPausedEvent(evt)) {
            this.comscoreFactory.getStreamingTag(evt).then(tag => {
                tag.adPaused();
            })
        }
        else if (isPlayerAdResumedEvent(evt)) {
            this.comscoreFactory.getStreamingTag(evt).then(tag => {
                tag.adResumed();
            })
        }



    }
    protected onMediaProgress(progEvent: MediaProgressEvent, corrected_percentage: number): void {
        //nothing to do
    }

    protected onMediaEvent(evt: MediaEvent<VideoInfoRawData>): void {


        if (isMediaStartedEvent(evt)) {
            this.comscoreFactory.getStreamingTag(evt).then(tag => tag.play(0));
            // stesso executionId → stesso streamid dell'SDK Video (Doc F). Vedi generateUID().
            this.pairingPingFactory.sendPairingPing(generateUID(evt.executionId)).catch(err => {
                console.warn("Errore invio Audicom Pairing Ping:", err);
            });
        }
        else if (isMediaPausedEvent(evt) && evt.origin == MediaControlOrigin.USER) {
            this.comscoreFactory.getStreamingTag(evt).then(tag => tag.pause());
        }
        else if (isMediaResumedEvent(evt)) {
            this.comscoreFactory.getStreamingTag(evt).then(tag => tag.play(evt.currentTime));
        }
        else if (isMediaCompleteEvent(evt)) {
            this.comscoreFactory.getStreamingTag(evt).then(tag => tag.end());
        }
        else if (isMediaPlaylistStartedEvent(evt)) {
            this.comscoreFactory.getStreamingTag(evt);
        }
        else if (isMediaBufferingEvent(evt)) {
            this.comscoreFactory.getStreamingTag(evt).then(tag => tag.bufferStart());
        }
        else if (isMediaBufferEndEvent(evt)) {
            this.comscoreFactory.getStreamingTag(evt).then(tag => tag.bufferEnd());
        }

    }



} 